module.exports = __webpack_public_path__ + "img/logo.129f697e.png";